import { INTEGRATION_REQUEST_API, BRANDID } from '../constants';
import setIntegrationFoldToDefault from './integrations';

const searchField = document.getElementById('search-field');

(function integrationRegister() {
  let integrationInfo = {};
  const integrationBtn = document.querySelector('#integrationRequestSubmit');

  function nameFieldValidateWithSpaces(event) {
    if (event.target.id === 'integration-name' && event.target.value.trim() === '') {
      event.target.classList.add('invalid');
      integrationBtn.setAttribute('disabled', true);
    } else {
      event.target.classList.remove('invalid');
      integrationBtn.removeAttribute('disabled');
    }
  }


  function onFocus(event) {
    if (event.target.classList.contains('invalid')) {
      event.target.classList.remove('invalid');
    }
  }

  function onBlur(event, info) {
    if (event.target.id === 'integration-name') {
      nameFieldValidateWithSpaces(event);
    }
    integrationInfo[info.emittedBy] = info;
  }

  function integrationInfoObject(descriptionFieldID, emailFieldID, nameFieldID) {
    return {
      fields: {
        integrationRequest: {
          selector: descriptionFieldID, type: 'text',
        },
        email: { selector: emailFieldID, type: 'email', errorClassName: 'invalid' },
        name: { selector: nameFieldID, type: 'text', errorClassName: 'invalid' },
      },
      eventListeners: {
        blur: onBlur,
        focus: onFocus,
      },
    };
  }

  integrationInfo = window.InputValidator && window.InputValidator.fields.initialize({
    ...integrationInfoObject('#integrationRequest', '#integration-email', '#integration-name'),
  });

  function isIntegrationInfoValid() {
    // allow empty description field
    integrationInfo.integrationRequest.valid = true;
    if (searchField.value !== '') {
      integrationInfo.name.valid = true;
    }
    if (integrationBtn.getAttribute('disabled')) {
      integrationInfo.name.valid = false;
    }
    return (
      integrationInfo
      && Object.keys(integrationInfo).length
      && Object.values(integrationInfo).every(value => value.valid)
    );
  }

  function setIntegrationFormToNormalState() {
    document.getElementById('inner-integration-form').reset();
    integrationInfo = window.InputValidator && window.InputValidator.fields.initialize({
      ...integrationInfoObject('#integrationRequest', '#integration-email', '#integration-name'),
    });
    integrationBtn.setAttribute('style', 'pointer-events: initial;cursor: pointer;');
    document.getElementById('integration-request').classList.remove('loading');
    document.querySelector('.integration-request').classList.add('submitted');
  }

  async function processIntegrationRequest(payload) {
    try {
      let response = await window.fetch(INTEGRATION_REQUEST_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      response = await response.json();
      if (response && response.success) {
        setIntegrationFormToNormalState();
        setIntegrationFoldToDefault();
        document.getElementById('integration-form').classList.add('hide');
        document.getElementById('thank-you').classList.remove('hide');
      }
    } catch (e) {
      setIntegrationFormToNormalState();
      setIntegrationFoldToDefault();
      console.error(e) // eslint-disable-line
    }
  }

  integrationBtn.addEventListener('click', () => {
    if (isIntegrationInfoValid()) {
      integrationBtn.setAttribute('style', 'pointer-events: none;cursor: default;');
      document.getElementById('integration-request').classList.add('loading');

      if (searchField.value !== '' && integrationInfo.name.value === '') {
        integrationInfo.name.value = searchField.value;
      }

      processIntegrationRequest({
        brandId: BRANDID,
        name: integrationInfo.name.value,
        email: integrationInfo.email.value,
        integrationRequest: integrationInfo.integrationRequest.value,
      });
    } else if (integrationInfo && Object.keys(integrationInfo).length) {
      Object.values(integrationInfo).forEach((value) => {
        const element = document.querySelector(value.selector);
        if (!value.valid && element && value.value === '' && value.selector !== '#integrationRequest') {
          element.classList.add('invalid');
        }
      });
    }
  });
}());
